import {API, Setup} from '../../Services';

function checkRequestExistInLocal(req){
    let find = localStorage.getItem(req)
    if(find){
        return find
    }
    return  false
}

function storeRequestInLocal(req,data) {
    let stringData = JSON.stringify({time:new Date().getTime(),data:data})
    localStorage.setItem(req,stringData)
}

export async function AxiosCache({url,config,time}) {
    return new Promise(async (resolve, reject) => {
        let req =url
        let maxAge = time
        let existCach = checkRequestExistInLocal(req)
        if(existCach) {
            let cachedData = JSON.parse(existCach)
            let now = new Date().getTime()
            let cacheTime = cachedData.time;
            let diff = (now - cacheTime)/1000
            if(diff<maxAge){
                // console.info("load from cache : ",url,diff)
                resolve(cachedData.data)
                return
            }
        }
        let result =  await API.get(url,config);
        storeRequestInLocal(req,result.data)
        // console.info("get from API : ",url)
        resolve(result.data)
    })
}
